import styled from 'styled-components'

export const Title = styled.h2`
  font-weight: ${props => props.theme.fonts.mediumWeight};
  font-size: ${props => props.theme.fonts._24};
  font-size: ${props => props.theme.fonts._28};
  color: ${props => props.theme.colors.textColor};
`

export const RateName = styled.div`
  margin-bottom: 20px;
  margin-top: 30px;
  font-weight: ${props => props.theme.fonts.mediumWeight};
  font-size: ${props => props.theme.fonts._18};
  font-size: ${props => props.theme.fonts._22};
  color: ${props => props.theme.colors.textColor};
`

export const Paragraph = styled.div`
  color: ${props => props.theme.colors.labelTextColor};
  font-size: ${props => props.theme.fonts._14};
  line-height: ${props => props.theme.fonts._24};
`
